import { Component, computed, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { PathFromItemPipe } from "../../../../common/pipes/path-from-item.pipe";
import { sanitizeDirectusObject } from "../../../../common/utils/sanitize-directus-object";
import { ItemsConfirmationBlock } from "../../../api/packbo/models/items-confirmation-block";

@Component({
    selector: "packbo-confirmation-block",
    templateUrl: "./confirmation-block.template.html",
    imports: [DirectusTranslationPipe, PathFromItemPipe]
})
export class ConfirmationBlockComponent {
    public readonly confirmationBlock = input.required<ItemsConfirmationBlock>();
    public readonly link = computed(() => sanitizeDirectusObject(this.confirmationBlock().link));
}
